import { StatusType } from 'components/atoms/Status/constants'
import { DebinInternalStatus } from 'store/debin/types'

export const getDebinStatus = (status?: DebinInternalStatus) => {
  switch (status) {
    case DebinInternalStatus.PENDING:
      return StatusType.IN_PROGRESS
    case DebinInternalStatus.COMPLETED:
      return StatusType.HE_FINISHED
    case DebinInternalStatus.CANCELED:
      return StatusType.CANCELED
    case DebinInternalStatus.REJECTED:
      return StatusType.HE_REJECTED
    default:
      return StatusType.PENDING
  }
}
